export const viewportSizes = {
  MOBILE: 0,
  MOBILE_SMALL: 480,
  TABLET_PORTRAIT: 600,
  TABLET_LANDSCAPE: 905,
  LAPTOP: 1240,
  DESKTOP: 1440,
} as const;

export const getPrefersReducedMotion = () => {
  const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  return motionQuery.matches;
};
